import { handleApiError } from '../core/apiError';
import axiosInstance from '../core/axiosInstance';


/**
 * Sends a request to the server to authenticate the user and log them in.
 * 
 * This function accepts the user's username and password, and sends a POST request 
 * to the login endpoint. The server response (such as the user token) will be returned.
 * It uses the default Axios instance with pre-configured headers and base URL.
 * 
 * @function
 * @returns {Promise<Object>} - A promise that resolves to the server's response data (e.g., user data or token).
 * @throws {Error} - Throws an error if the login request fails.
 * 
 */
export const getAllSubscriptionPlan = async () => {
    try {
        const response = await axiosInstance.get('/subscription-plan');
        return response?.data; // Server response, typically contains user data or token
    } catch (error) {
        handleApiError(error);
    }
};

export const getSubscriptionDetailsByUserId = async () => {
    try {
        const response = await axiosInstance.get('/user-subscription/plan-detail');
        return response?.data; // Server response, typically contains user data or token
    } catch (error) {
        handleApiError(error);
    }
};

